<template>
  <div :class="joinClasses('overview-warning', modifiers)">
    <div class="overview-warning__count typo-tiny">
      <UseSvg
        class="icon icon--small"
        :name="icon"
      />
      {{ count }}
    </div>
    <div class="overview-warning__label typo-tiny">
      {{ label }}
      <slot />
    </div>
  </div>
</template>
<script setup>
import UseSvg from '@/components/generic/use_svg.vue';
import { computed } from 'vue';
import joinClasses from '@/functions/join_classes';
const props = defineProps({
  count: { type: Number, required: false, default: null },
  label: { type: String, required: false, default: null },
  notice: { type: Boolean, required: false },
  modifiers: { type: Array, default: () => [] },
});
const icon = computed(() => {
  return props.notice ? 'i_encircled' : 'exclamation_triangle';
});
</script>
<style scoped lang="scss">
@import '@/stylesheets/global';
.overview-warning {
  $block: &;
  align-items: center;
  color: $white;
  display: flex;
  margin-bottom: bu(1);

  &__count {
    display: flex;
    align-items: center;
    font-weight: 700;
    margin-right: bu(1);
    svg {
      margin-right: bu(1);
    }
  }

  &--flat {
    margin: 0;
  }

  &--inline {
    display: inline-flex;
  }
}
</style>
